// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
    production: false,
    crudSampleApiURL: 'api/ui/crud-sample',
    seApiURL: 'http://49.205.177.208:6003/cd',
    // seApiURL: 'http://172.20.10.2:6003/cd',  //CP SIR asif
    // seApiURL: 'http://192.168.29.246:6003/cd',  //CP SIR IP
    aiApiUrl: 'http://122.180.240.197:5407',
    s3FileBktUrl: 'https://s3.amazonaws.com/dev.sourceease',
    version: '1.0.0'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.

